/**
 * Company lead rules for the signed-in company_admin's own company (viq-vault
 * spec 2026-09-14-company-lead-rules-design §2.1). Backend: viq-backend
 * apps/customer-portal/src/handlers/leadRules.ts — company_admin only; the
 * company comes from the token.
 */
import type { LeadRulesResponse, SaveLeadRulesInput } from '@viq-admin/types';
import { adminFetch } from './dataProvider';

const PATH = '/v1/admin/company/lead-rules';

export function getLeadRules(): Promise<LeadRulesResponse> {
  return adminFetch<LeadRulesResponse>(PATH);
}

export function saveLeadRules(input: SaveLeadRulesInput): Promise<LeadRulesResponse> {
  return adminFetch<LeadRulesResponse>(PATH, { method: 'PUT', body: JSON.stringify(input) });
}
